// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__6+UtR","ulList":"List_ulList__6E8rb","pointer":"List_pointer__bIAmy","noBullets":"List_noBullets__-c2lp"};